import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogTitle,
} from '@angular/material/dialog';
import { SharedModule } from '../../shared.module';
import { GeneralAlertDialogComponent } from './general-alert-dialog.component';

@NgModule({
  declarations: [GeneralAlertDialogComponent],
  imports: [
    SharedModule,
    MatDialogModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
  ],
  exports: [GeneralAlertDialogComponent],
})
export class GeneralAlertDialogModule {}
